<template>
    <div class="card mb-0">
        <div class="card-header">
            <table style="width: 100%;">
                <tbody>
                <tr>
                    <td>{{ title }}</td>
                    <td style="font-weight: normal;text-align: right;">
                        <template v-if="!readonly">
                            <DropDownAction :action="actions.downloadDocument" :forward-events="true"
                                            v-on:forward-event="$emit($event.event, $event.data)"
                                            v-if="actions && actions.downloadDocument"/>
                            <ButtonAction :action="actions.updateDocument" :forward-events="true"
                                          v-on:forward-event="$emit($event.event, $event.data)"
                                          v-if="actions && actions.updateDocument"/>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body">
            <table class="table table-borderless table-sm mb-0">
                <tbody>
                <tr>
                    <td class="p-0" style="width: 90px;" v-if="data.qr_code">
                        <QrCode :value="data.qr_code" size="80"/>
                    </td>
                    <td class="p-0" style="vertical-align: top;">
                        <table class="table table-borderless table-sm mb-0">
                            <tbody>
                            <tr>
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Number') }}</b></td>
                                <td class="p-0">{{ data.financial_year_number }}</td>
                            </tr>
                            <tr v-if="data.reference">
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Reference') }}</b></td>
                                <td class="p-0">{{ data.reference }}</td>
                            </tr>
                            <tr>
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Name') }}</b></td>
                                <td class="p-0">{{ data.name }}</td>
                            </tr>
                            <tr v-if="data.date">
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Date') }}</b></td>
                                <td class="p-0">{{ data.date }}</td>
                            </tr>
                            <tr v-else>
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Valid') }}</b></td>
                                <td class="p-0">{{ data.valid_from + ' ' + $i18n.t('translations.until') + ' ' + data.valid_to }}</td>
                            </tr>
                            <tr v-if="data.delivery_date">
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Delivery Date') }}</b></td>
                                <td class="p-0">{{ data.delivery_date }}</td>
                            </tr>
                            <tr v-if="data.invoice_date">
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Invoice Date') }}</b></td>
                                <td class="p-0">{{ data.invoice_date }}</td>
                            </tr>
                            <tr v-if="data.invoice_number">
                                <td class="p-0" style="width: 135px;"><b>{{ $i18n.t('translations.Invoice Number') }}</b></td>
                                <td class="p-0">{{ data.invoice_number }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body light" style="border: none; padding: 0 .5rem;" v-if="actions && (actions.previousVersion || actions.nextVersion)">
            <div class="btn-toolbar" role="toolbar">
                <div class="btn-group btn-group-sm" role="group" v-if="actions.previousVersion">
                    <RouteAction :action="actions.previousVersion" :data="data"/>
                </div>
                <div class="btn-group btn-group-sm ml-auto" role="group" v-if="actions.nextVersion">
                    <RouteAction :action="actions.nextVersion" :data="data"/>
                </div>
            </div>
        </div>
        <div class="card-footer light" v-if="actions && (actions.copyDocument || (sketchUpBrowser && actions.toggleSketchUpOrder))">
            <table style="width: 100%;">
                <tbody>
                <tr>
                    <td>
                        <ToggleAction :action="actions.toggleSketchUpOrder"
                                      :toggled="linkedToSketchUp" :forward-events="true"
                                      v-on:forward-event="$emit($event.event, $event.data)"
                                      v-if="sketchUpBrowser && actions.toggleSketchUpOrder"/>
                    </td>
                    <td style="text-align: right;">
                        <DropDownAction :action="actions.copyDocument" :forward-events="true"
                                        v-on:forward-event="$emit($event.event, $event.data)"
                                        v-if="actions.copyDocument"/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ButtonAction from "@/components/actions/ButtonAction.vue";
import DropDownAction from "@/components/actions/DropDownAction.vue";
import QrCode from "@/components/QrCode.vue";
import RouteAction from "@/components/actions/RouteAction.vue";
import ToggleAction from "@/components/actions/ToggleAction.vue";

/* global sketchup:false */

export default {
    name: "DocumentCard",
    components: {
        ToggleAction,
        RouteAction,
        ButtonAction,
        DropDownAction,
        QrCode
    },
    props: ['title', 'data', 'linkedToSketchUp', 'actions', 'readonly'],
    data() {
        return {
            sketchUpBrowser: (typeof sketchup !== "undefined"),
        }
    },
}
</script>

<style scoped>
</style>
